export default __webpack_public_path__ + "static/media/crz.97dae047.svg";